<template>
  <div class="mt-4">
    <div class="card" style="background: #f5f5f5;">
      <div class="card-body" style="padding: 0.5rem !important;">
        <div class="row">
          <div class="container">
            <div class="col-sm-3 col-xl-3">
        	    <span style="vertical-align: -webkit-baseline-middle;"> Required Skills as of {{lastUpdatedDateTime(progress)}} </span>
        	    <button class="btn_close" @click="closeSkillProgressPopup" style="font-size: 30px;">
                <span class="ic-close"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-3">
      <span><strong>{{title}}</strong></span>
    </div>

    <div class="row mt-4 ml-5">
      <div class="col-sm-3 col-xl-3">
        <div class="d-flex flex-wrap align-items-center">
          <div id="skillProgressChart" v-show="isPieChartGenerated"></div>
          <div class="ml-5" v-if="isPieChartGenerated">
            <div class="status_row"><span class="lg_blc gc_completed"></span> Completed</div>
            <div class="status_row"><span class="lg_blc gc_in_progress"></span> In Progress</div>
            <div class="status_row"><span class="lg_blc gc_in_plan"></span> In the Plan</div>
            <div class="status_row"><span class="lg_blc gc_missing"></span>  Missing</div>
          </div>
          <div v-else class="w-100">
            <spinner size="large"></spinner>
          </div>
        </div>
      </div>
    </div>

		<div class="col-sm-3 col-xl-3">
      <!--
			<div class="mt-4">
        <span>Current Date {{currentDateTime()}}</span>
      </div>
      -->
      <div class="mt-4">
        <span>Last Calculated On {{lastUpdatedDateTime(progress)}}</span>
      </div>
      <div class="mt-4 float-right" style="padding-right: 0.5rem;">
        <button class="btn btn-primary" @click="recalculateSkillProgress">Re-calculate now</button>
      </div>
		</div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import moment from 'moment'
  import * as d3 from 'd3'

  export default {
    name: 'explore-career-skill-progress',
    props: ['title', 'careerId', 'streamId', 'skillProgressTargetId'],
    data: () => {
      return {
        progress: null,
        isPieChartGenerated: false
      }
    },

    mounted () {
      this.loadSkillProgress(false)
    },

    updated () {
      this.$nextTick(() => {
        if (this.progress) {
          let colorScale = {
            'completed': '#528016',
            'in progress': '#a1c75f',
            'scheduled': '#eb8807',
            'credits needed': '#e0291f'
          }
          this.generatePieChart(this.progress.values, colorScale, 'skillProgressChart')
        }
      })
    },

    methods: {
      ...mapActions([
        'loadCareerSkillProgress'
      ]),

      closeSkillProgressPopup () {
        this.$parent.skillProgressTargetId = ''
        this.$parent.selectedCareer = null
        this.$parent.showSkillProgressPopup = false
      },

      async loadSkillProgress (isRecalculate) {
        this.isPieChartGenerated = false
        this.progress = await this.loadCareerSkillProgress({streamId: this.streamId, careerId: this.careerId, recalculate: isRecalculate})
      },

      generatePieChart (data, colorScale, elementId) {
        $('#' + elementId).empty()
        if (data && data.length > 0) {
          var pieChartContainerHeight = 162
          var pieChartInnerRadius = 35
          var width = pieChartContainerHeight
          var height = pieChartContainerHeight
          var radius = pieChartContainerHeight / 2

          var canvas = d3.select('#' + elementId).append('svg')
                       .data([data]).attr('width', width).attr('height', height).append('g')
                       .attr('transform', 'translate(' + radius + ',' + radius + ')')

          var arc = d3.arc()
                    .outerRadius(radius)
                    .innerRadius(pieChartInnerRadius)

          var pie = d3.pie()
                    .value(function (d) { return d.value }).sort(null)

          var arcs = canvas.selectAll('.arc')
                     .data(pie(data))
                     .enter().append('g')
                     .attr('class', 'arc')

          arcs.append('path')
              .attr('d', arc)
              .style('fill', function (d, i) { return colorScale[d.data.label] })

          arcs.append('text')
              .attr('transform', function (d) { return 'translate(' + arc.centroid(d) + ')' })
              .style('font', 'bold 12px Arial')
              .style('fill', '#fff')
              .style('cursor', 'default')
              .attr('text-anchor', 'middle')
              .text(function (d) { return d.data.value })
        } else {
          $('#' + elementId).html('<strong>Not Available</strong>')
        }

        this.isPieChartGenerated = true
      },

      changeMillisToDate (millis, format) {
        return DateTime.fromMillis(millis, {zone: 'local'}).toFormat(format)
      },

      lastUpdatedDateTime (progress) {
        return (progress) ? this.changeMillisToDate(progress.lastUpdatedTime, 'MM/dd/yyyy @ hh:mm a') : ''
      },

      currentDateTime (progress) {
        let millis = moment().valueOf()
        if (progress && progress.currentTime) {
          millis = progress.currentTime
        }
        return this.changeMillisToDate(millis, 'MM/dd/yyyy (hh:mm a)')
      },

      recalculateSkillProgress () {
        this.loadSkillProgress(true)
      }
    }
  }
</script>


<style scoped>
  .status_row {
    display: flex;
    align-items: center;
    height: 33px;
    margin: 6px 0;
    min-width: 130px;
    font-size: 15px;
  }

  .lg_blc {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin: 0 12px 0 0;
  }

  .gc_completed {
    background: #528016;
  }

  .gc_in_progress {
    background: #a1c75f;
  }

  .gc_in_plan {
    background: #eb8807;
  }

  .gc_missing {
    background: #e0291f;
  }
</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreCareerSkillProgress.vue